import SEO from "../../components/SEO";
import { useState } from "react";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";

const FAQItem = ({ question, answer, isOpen, onClick }) => {
	return (
		<div className="border-b border-gray-200">
			<button
				className="w-full py-5 px-6 text-left flex justify-between items-center hover:bg-purple-50 transition-colors"
				onClick={onClick}
			>
				<span className="font-semibold text-gray-800 pr-4">{question}</span>
				{isOpen ? <BsChevronUp className="text-purple-600 flex-shrink-0" /> : <BsChevronDown className="text-purple-600 flex-shrink-0" />}
			</button>
			{isOpen && (
				<div className="px-6 pb-5 text-gray-700">
					{answer}
				</div>
			)}
		</div>
	);
};

export const FAQPage = () => {
	const [openIndex, setOpenIndex] = useState(null);

	const faqs = [
		{
			question: "How does Parcelin work?",
			answer: "Parcelin connects you with drivers who are already traveling your route. Simply select your pickup and delivery locations, choose your parcel size, and we'll match you with a verified driver. It's like carpooling, but for your packages!"
		},
		{
			question: "What areas do you service?",
			answer: "We currently operate in Limpopo (Polokwane, Giyani, Malamulele, Tzaneen, Bungeni, Thohoyandou and Phalaborwa) and all of Gauteng. We're rapidly expanding to cover more areas across South Africa."
		},
		{
			question: "How much does delivery cost?",
			answer: "Our pricing varies based on distance, parcel size, and delivery speed. We offer same-day and next-day delivery options. You'll see the exact price before confirming your booking."
		},
		{
			question: "Is my parcel insured?",
			answer: "Yes, all parcels are covered by our basic insurance. Additional insurance options are available for high-value items during the booking process."
		},
		{
			question: "How do I track my parcel?",
			answer: "Once your parcel is picked up, you'll receive a tracking number. You can track your parcel in real-time through your account dashboard or our tracking page."
		},
		{
			question: "What payment methods do you accept?",
			answer: "We accept EFT via Payfast, as well as mobile payments including E-wallet, Money Send, Payshap, and Capitec transfers."
		},
		{
			question: "Can I schedule a pickup for a specific time?",
			answer: "Yes! During booking, you can select your preferred collection date. Our drivers will coordinate with you for a specific pickup time."
		},
		{
			question: "What items can I send?",
			answer: "You can send most non-hazardous items including documents, clothing, electronics, and personal items. Prohibited items include illegal substances, weapons, and hazardous materials."
		},
		{
			question: "How is Parcelin environmentally friendly?",
			answer: "We utilize vehicles already on the road rather than adding more cars. This reduces carbon emissions, traffic congestion, and our overall environmental impact. Every delivery with Parcelin is a greener choice."
		},
		{
			question: "What if my parcel is damaged or lost?",
			answer: "In the rare event of damage or loss, contact our support team immediately. All parcels are insured, and we'll work quickly to resolve the issue and process any claims."
		},
		{
			question: "How do I become a Parcelin driver?",
			answer: "If you regularly travel between our service areas, you can sign up as a driver through our platform. You'll need a valid driver's license, vehicle registration, and to pass our verification process."
		},
		{
			question: "Can I cancel or modify my booking?",
			answer: "Yes, you can cancel or modify your booking before the driver picks up your parcel. Cancellation fees may apply depending on how close to pickup time you cancel."
		}
	];

	return (
		<div className="w-full min-h-screen bg-gradient-to-br from-cyan-100 to-fuchsia-200 py-12 px-5"><SEO title="FAQ" description="Frequently asked questions about Parcelin parcel delivery. Service areas, pricing, tracking, insurance, and more." path="/faq" />
			<div className="max-w-4xl mx-auto">
				<div className="text-center mb-12">
					<h1 className="text-4xl md:text-5xl font-bold text-purple-800 mb-4">Frequently Asked Questions</h1>
					<p className="text-lg text-gray-700">Everything you need to know about Parcelin</p>
				</div>

				<div className="bg-white rounded-xl shadow-lg overflow-hidden">
					{faqs.map((faq, index) => (
						<FAQItem
							key={index}
							question={faq.question}
							answer={faq.answer}
							isOpen={openIndex === index}
							onClick={() => setOpenIndex(openIndex === index ? null : index)}
						/>
					))}
				</div>

				<div className="mt-12 text-center bg-white rounded-xl p-8 shadow-lg">
					<h2 className="text-2xl font-bold text-purple-800 mb-4">Still have questions?</h2>
					<p className="text-gray-700 mb-6">Can't find the answer you're looking for? Our support team is here to help.</p>
					<a href="/contact" className="inline-block bg-purple-600 text-white px-8 py-3 rounded-full hover:bg-purple-700 transition-colors">
						Contact Support
					</a>
				</div>
			</div>
		</div>
	);
};
